module.exports = __webpack_public_path__ + "static/media/customerWhiteIcon.6bbf9785.png";